import plur from 'plur'
import {useMemo, useState} from 'react'

import {amountDaysOfWeek} from '../JobTriggerForm/JobTriggerForm.consts'

import {currentTimeZone} from './PipelineTrigger.consts'
import type {TriggerEditData} from './PipelineTrigger.types'
import {getDaysOfWeekLabel, getNextTriggerDate, getTimeLabel} from './PipelineTrigger.utils'

function usePipelineTrigger(
  parameters: Record<string, string>,
  onApply: (parameters: TriggerEditData) => void,
) {
  const [isShowTriggerForm, setIsShowTriggerForm] = useState<boolean>(false)
  const {
    daysOfWeek: parameterDaysOfWeek = '',
    hour: parameterHour = '00',
    minute: parameterMinute = '00',
    timezone = currentTimeZone,
  } = parameters
  const daysOfWeek = useMemo(() => {
    if (!parameterDaysOfWeek) {
      return []
    }
    return parameterDaysOfWeek.split(',')
  }, [parameterDaysOfWeek])
  const isEveryDay = daysOfWeek.length === amountDaysOfWeek || !daysOfWeek.length
  const detailWhenTriggerLabel = useMemo(() => {
    const {days, hours, minutes} = getNextTriggerDate(
      daysOfWeek,
      Number(parameterHour),
      Number(parameterMinute),
      isEveryDay,
    )
    const isNow = !days && !hours && !minutes
    const daysText = days ? `${days} ${plur('day', days)}` : ''
    const hoursText = hours ? `${hours} ${plur('hour', hours)}` : ''
    const minutesText = minutes ? `${minutes} ${plur('minute', minutes)}` : ''

    if (isNow) {
      return 'Will be triggered now'
    }

    return `Will be triggered in ${daysText} ${hoursText} ${minutesText}`
  }, [parameterHour, parameterMinute, daysOfWeek, isEveryDay])
  const handlerJobTriggerApplyChange = (value: TriggerEditData) => {
    onApply(value)
    setIsShowTriggerForm(false)
  }
  const handlerEditButtonClick = () => setIsShowTriggerForm(true)
  const handlerJobTriggerFormClose = () => setIsShowTriggerForm(false)

  return {
    isShowTriggerForm,
    daysOfWeekLabel: getDaysOfWeekLabel(parameterDaysOfWeek),
    detailWhenTriggerLabel,
    timeLabel: getTimeLabel(parameters),
    timezone,
    parameterHour,
    parameterMinute,
    daysOfWeek,
    handlerJobTriggerApplyChange,
    handlerJobTriggerFormClose,
    handlerEditButtonClick,
  }
}

export default usePipelineTrigger
